import {createApp} from 'vue';
import App from './App.vue';
import router from './router/index.js';
import 'bootstrap';
import i18n from './i18n';
import store from './store';
import common from './js/common.js';
import logger from './logger/index.js';

const app = createApp({
  extends: App,
}).use(i18n);

app.use(router);
app.use(store);
app.use(common);
app.use(logger);
app.mount('#app');
